var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"flex px-2"},[_c('Sidebar'),_c('div',{staticClass:"app-wrapper"},[_c('Navbar'),_c('transition',{attrs:{"name":"el-fade-in","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }